// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"gS-z","inlineTitle":"hS-z","sponsoredAdsWrapper":"iS-z","marketplaceRecosWrapper":"jS-z"};